import layout from '@/views/layout/layout.vue'
const inStockList = r => require.ensure([], () => r(require('@/views/antiChannelConflict/inStock/list.vue')), 'group-antiChannelConflict-inStock')

const antiChannelConflictInStock = [
  {
    path: '/antichannelconflict/instock',
    name: 'antiChannelConflict-inStock',
    component: layout,
    redirect: '/antichannelconflict/instock/list',
    children: [
      {
        path: 'list',
        component: inStockList,
        name: 'antiChannelConflict-inStock-list',
        meta: {
          displayName: '入库单管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default antiChannelConflictInStock



// WEBPACK FOOTER //
// ./src/router/antiChannelConflict/inStock.js